import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { formatPrice } from "utils/utils";

const AccountingResumeCard = ({ total, totalsPerType }) => {
  if (!total) return null;

  const resumeData = [
    { label: "PAYMENT BILL", value: total.payment_bill },
    { label: "NET AGENT", value: total.net_agent },
    { label: "SUSUK AGENT", value: total.susuk_agent },
    { label: "OTHERS", value: total.others },
    { label: "NET KUBER", value: total.net_kuber },
  ];

  const renderItem = (item, isChild = false) => (
    <div
      key={item.label}
      className={`mb-2 p-2 border rounded ${
        isChild ? "ms-4 bg-light" : "bg-white"
      }`}
    >
      <div className="d-flex justify-content-between">
        <strong>{item.label}:</strong>
        <span className="font-weight-bold">{formatPrice(item.value)}</span>
      </div>
    </div>
  );

  return (
    <Card className="mt-4 border-primary">
      <Card.Header className="bg-success text-white">
        <h5 className="mb-0">RESUME TRANSAKSI</h5>
      </Card.Header>
      <Card.Body className="border-top">
        <Row>
          <Col md={6}>
            <h6 className="mb-3 text-muted">GRAND TOTALS</h6>
            {resumeData.map((item) => renderItem(item))}
          </Col>
          <Col md={6}>
            <h6 className="mb-3 text-muted">TOTALS PER TYPE</h6>
            <div style={{ maxHeight: '400px', overflowY: 'auto', paddingRight: '10px' }}>
              {Object.entries(totalsPerType || {}).map(([type, totals]) => (
                <div key={type} className="mb-3 p-2 border rounded bg-light">
                  <div className="d-flex justify-content-between border-bottom pb-1 mb-2">
                    <strong className="text-primary">{type.toUpperCase()}</strong>
                    <span className="badge">{totals.count} bookings</span>
                  </div>
                  <div className="small">
                    <div className="d-flex justify-content-between">
                      <span>Payment Bill:</span>
                      <span>{formatPrice(totals.payment_bill)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Net Agent:</span>
                      <span>{formatPrice(totals.net_agent)}</span>
                    </div>
                    <div className="d-flex justify-content-between text-warning">
                      <span>Other:</span>
                      <span>{formatPrice(totals.others)}</span>
                    </div>
                    <div className="d-flex justify-content-between text-danger">
                      <span>Deduction (Net of Other):</span>
                      <span>{formatPrice(totals.deduction)}</span>
                    </div>
                    <div className="d-flex justify-content-between text-success font-weight-bold border-top mt-1 pt-1">
                      <strong>Net Kuber:</strong>
                      <strong>{formatPrice(totals.net_kuber)}</strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default AccountingResumeCard;
